import React, { Component } from 'react';
import './LoginLayout.css';

class LoginLayout extends Component {

    render () {
        return (
            <div className="hold-transition login-page">
                {this.props.children}
            </div>
        )
    }
}

export default LoginLayout;